import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


interface MetricCardProps {
  label: string;
  value: string;
  subValue?: string;
  trend?: number;
  trendLabel?: string;
  variant?: 'default' | 'positive' | 'negative' | 'warning' | 'info' | 'critical';
  icon?: React.ElementType;
  iconColor?: string;
  mono?: boolean;
  className?: string;
}

export default function MetricCard({
  label, value, subValue, trend, trendLabel,
  variant = 'default', icon: Icon, iconColor, mono, className = ''
}: MetricCardProps) {
  const variantClass = {
    default: 'glass-card',
    positive: 'metric-positive',
    negative: 'metric-negative',
    warning: 'metric-warning',
    info: 'metric-info',
    critical: 'metric-critical',
  }[variant];

  const TrendIcon = trend === undefined ? null : trend > 0 ? TrendingUp : trend < 0 ? TrendingDown : Minus;
  const trendColor = trend === undefined ? '' : trend > 0 ? 'text-positive' : trend < 0 ? 'text-negative' : 'text-muted-foreground';

  return (
    <div className={`rounded-xl p-4 card-hover ${variantClass} ${className}`}>
      <div className="flex items-start justify-between mb-3">
        <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">{label}</p>
        {Icon && (
          <div className={`w-8 h-8 rounded-lg flex items-center justify-center bg-surface-3 ${iconColor || 'text-primary'}`}>
            <Icon size={16} />
          </div>
        )}
      </div>
      <p className={`text-2xl font-bold text-foreground mb-1 ${mono ? 'font-mono-data' : ''}`}>{value}</p>
      {subValue && <p className="text-xs text-muted-foreground mb-2">{subValue}</p>}
      {(trend !== undefined || trendLabel) && TrendIcon && (
        <div className={`flex items-center gap-1 text-xs font-medium ${trendColor}`}>
          <TrendIcon size={12} />
          <span>{Math.abs(trend || 0).toFixed(1)}%</span>
          {trendLabel && <span className="text-muted-foreground font-normal ml-1">{trendLabel}</span>}
        </div>
      )}
    </div>
  );
}